import { NgModule } from '@angular/core';
import { ListviewOrderComponent } from './listview-order.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AngularFrameworkModule } from 'sp-office365-framework';
import { FuseSharedModule, LayoutModule } from 'sp-office365-layout';

const routes = [
    {
        path: 'orders',
        component: ListviewOrderComponent,
    },
];

@NgModule({
    declarations: [ListviewOrderComponent],
    imports: [
        RouterModule.forChild(routes),
        TranslateModule,
        FuseSharedModule,
        LayoutModule,
        AngularFrameworkModule,
    ],
    exports: [ListviewOrderComponent],
})
export class ListviewOrderModule {}
